import styled from "styled-components";
import { Layout, Typography } from "antd";
import { Button, Image, Text, Constants, Box } from "@nubeteck/components";

const { maxDevice } = Constants;
const { Header } = Layout;

export const HeaderStyled = styled(Header)`
  height: 60px;
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 15;

  display: flex;
  align-items: center;
  gap: 15px;
  padding-inline: 24px;

  background-color: ${({ theme }) => theme.colors.colorAccent};
  font-weight: 600;
  /* evita saltos raros y que los hijos se empujen */
  flex-wrap: nowrap;

  @media ${maxDevice.tablet} {
    height: 80px;
    justify-content: space-between;
  }

  @media (max-width: 1280px) {
    height: 80px;
    justify-content: space-between;
  }
`;

export const HomeLogo = styled(Image)`
  margin-bottom: 5px;
  flex: 0 0 auto;

  @media ${maxDevice.tablet} {
    display: flex;
    align-items: center;
  }

  @media (max-width: 1280px) {
    min-width: 75px !important;
    display: flex;
    align-items: center;
  }
`;

export const HeaderText = styled(Text)`
  color: #fff;
  white-space: nowrap;
  /* que pueda encogerse y hacer elipsis */
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 1280px) {
    font-size: 18px;
    display: none; /* opcional: oculta título en móvil para priorizar controles */
  }
`;

export const MenuStyled = styled.ul`
  /* 👇 en desktop el menú va en el centro con flex, no absolute */
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;

  /* toma espacio central, pero puede encogerse sin empujar a la derecha */
  flex: 1 1 auto;
  min-width: 0;
  gap: 6.5px;
  font-size: 14px;

  li {
    list-style-type: none;
    min-width: fit-content;
  }
  a {
    padding: 3px;
    color: #fff;
    white-space: nowrap;
    &.is-active {
      border-bottom: 1px solid #fff;
    }
  }

  /* en tablet/móvil se oculta y usamos el menú móvil */
  @media ${maxDevice.tablet} {
    display: none;
  }
  @media (max-width: 1280px) {
    display: none;
  }
`;

export const UserSectionStyled = styled(Box)`
  /* 👇 quita absolute y usa auto para "pegar" a la derecha */
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 20px;
  height: 60px;

  /* en móvil: NO ocultes el bloque entero, solo lo accesorio */
  @media (max-width: 1280px) {
    height: 40px;
    padding-right: 0;
    .username,
    .role-dropdown,
    .language-switcher {
      display: none; /* oculta LanguageSwitcher, username y roles en móvil */
    }
  }
`;

export const DropdownContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0px;
  margin-bottom: 10px;
  font-size: 14px;

  .username {
    max-inline-size: 145px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const DropdownLinkStyled = styled(Typography.Link)`
color: white !important;
display: inline-flex;
align-items: center;
line-height: 1;
margin-top: -20px;
span {
  font-size: 13px;
  position: relative;
  top: 2px;
  right: 5px;
}
`;

export const MobileMenuButtonStyled = styled(Button)`
  display: none;
  background: none;
  color: white;
  padding: 13px 16px;
  height: 50px;
  gap: 12px;
  border: none;

  span { color: #fff; font-size: 20px; }
  .ant-btn-icon span { font-size: 25px; }

  @media (max-width: 1280px) {
    display: inline-flex;
    align-items: center;
  }
`;